/**
 * AssetUserEvents
 * Registry of events for the Assets table + components
 */
export enum AssetUserEvents {
    ExpandTableRow = "AssetTable - Expand Table Row",
    CollapseTableRow = "AssetTable - Collapse Table Row",
    ClickAssetClass = "AssetTable - Click Asset Class Link",
    ClickProtocolLink = "AssetTable - Click Protocol Link",
    ClickNetworkLink = "AssetTable - Click Network Link",
    ClickTokenNetworkLink = "AssetTable - Click Token Network Link",
    ClickNetworkLogoLink = "AssetTable - Click Network Logo Link",
    ClickWormholeBadge = "AssetIndividual - Click Wormhole Badge",
    IndividualWebsiteLink = "AssetIndividual - Click Website Link",
    TransparencyCellLink = "AssetTable - Clink Transparency Cell Link",
    TransactionsChangeTab = "AssetTransactions - Change Tab",
    TransactionsLoginCTA = "Asset Transactions - Login CTA",
    TickerLinkClick = "AssetTicker - Click Link",
    TokenTableNetworkLinkClick = "TokenTable - Click Network Link",
    AssetRatingsDocumentLinkClick = "AssetRatings - Click Document Link",
    AssetHeaderPlatformLink = "AssetHeader - Click Platform Link",
    CardLoginToUnlock = "AssetIndividual Card - Login to Unlock",
    ClickIndividualLink = "Asset Table - Click Individual Link",
    ClickWebsiteLink = "AssetTable - Click Website Link",
    ClickManagerIndividualLink = "AssetTable - Click Manager Individual Link",
    ClickUnderlyingAssetLink = "AssetTable - Click Underlying Asset Link",
    ClickPeggedAssetLink = "AssetTable - Click Pegged Asset Link",
    ClickSparklineChart = "AssetTable - Click Sparkline Chart",
    AssetHeaderVisitProduct = "asset_header_visit_product",
    AssetHeaderOpenHowToBuy = "asset_header_open_how_to_buy",
    AssetHeaderSubmitAccessRequest = "asset_header_submit_access_request",
    ClickLatestAssetsLink = "Latest Assets - Click Asset Link",
    ClickLatestAssetsViewAll = "Latest Assets - Click View All Link",
    ClickActiveOpportunitiesLink = "Active Opportunities - Click Asset Link",
    ClickActiveOpportunitiesViewAll = "Active Opportunities - Click View All Link",
    FactsTableClickLoginToUnlock = "Asset Facts Table - Click Login to Unlock",
    ComparisonClickLoginToUnlock = "Asset Comparison - Click Login to Unlock",
    ClickServiceProviderLink = "Asset Table - Click Service Provider Link",
    UpgradeCtaView = "AssetIndividual - Upgrade CTA - View",
    UpgradeCtaClickViewPricing = "AssetIndividual - Upgrade CTA - Click View Pricing",
}
